"use client"

import { useEffect, useState } from "react"

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem("lumensis_cookie_consent")) {
      setVisible(true)
    }
  }, [])

  const accept = () => {
    localStorage.setItem("lumensis_cookie_consent", "accepted")
    // Grant analytics consent to Google Analytics
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: "granted" })
    }
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem("lumensis_cookie_consent", "declined")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-lg rounded-2xl border border-[var(--border-subtle)] bg-white p-5 shadow-lg">
        <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
          We use cookies for anonymised analytics (Google Analytics) to improve
          the experience.{" "}
          <a href="/privacy" className="text-[var(--gold)] underline">
            Privacy Policy
          </a>
        </p>
        <div className="mt-4 flex items-center gap-3">
          <button
            onClick={accept}
            className="rounded-full bg-[var(--text-primary)] px-5 py-2 text-xs font-semibold text-white transition-colors hover:bg-[var(--text-secondary)]"
          >
            Accept
          </button>
          <button
            onClick={decline}
            className="rounded-full border border-[var(--border-default)] px-5 py-2 text-xs font-semibold text-[var(--text-secondary)] transition-colors hover:bg-[var(--bg-elevated)]"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
